import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ReservedRacksSoRequest {
    @ApiProperty()
    rackId: number;
    @ApiProperty()
    saleOrderId: number;
   
}